import { Component, OnInit, inject } from '@angular/core';
import { LoaderService } from 'app/services/loader.service';
import { ActivatedRoute } from '@angular/router';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { ResourceNewsletterComponent } from './resource-newsletter.component';
import { ResourcePlanningComponent } from './resource-planning.component';
import { ResourcePricingComponent } from './resource-pricing.component';

@Component({
    templateUrl: './resource.component.html',
    imports: [MenuComponent, ResourceNewsletterComponent, ResourcePlanningComponent, ResourcePricingComponent]
})
export class ResourceComponent implements OnInit{
  private route = inject(ActivatedRoute);
  private loaderService = inject(LoaderService);

  public subMenuItems = [
    {key :'newsletters', title: 'Quarterly Portfolio Review'},
    {key :'plannings', title: 'Investment Pool Information'},
    {key :'thinking', title: 'Our Thinking'},
    {key :'events', title: 'News & Events'},
    {key :'giving', title: 'Giving'},
  ];

  ngOnInit(): void{
    this.route.params.subscribe(
      params => {
        this.loaderService.navigateTo.next(params['tag']);
      }
    );
  }

}